import { RootState } from "store/index";
import { RecipeFrontEndTransaction } from "client/blueChef";

const recipeDetailSelector = (
  state: RootState,
): RecipeFrontEndTransaction | null => state.recipeDetail.recipe;

export default recipeDetailSelector;
